 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~ForgotPassword-vue~Form-vu~b09ba6e6":"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~ForgotPassword-vue~Form-vu~b09ba6e6","Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~Form-vue~Forms-vue~Index-v~63b074e9":"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~Form-vue~Forms-vue~Index-v~63b074e9","Account-vue~Documents-vue~ForgotPassword-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~I~2300ad8d":"Account-vue~Documents-vue~ForgotPassword-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~I~2300ad8d","Account-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~Login-vue~Planner-vue~Planners-vue~c740871e":"Account-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~Login-vue~Planner-vue~Planners-vue~c740871e","Account-vue":"Account-vue","Form-vue":"Form-vue","Forms-vue":"Forms-vue","Index-vue":"Index-vue","Inspection-vue":"Inspection-vue","Issue-vue":"Issue-vue","Login-vue":"Login-vue","Planner-vue":"Planner-vue","Planners-vue":"Planners-vue","RegisterUser-vue":"RegisterUser-vue","Reports-vue":"Reports-vue","TimeClock-vue":"TimeClock-vue","TimeClockDetail-vue":"TimeClockDetail-vue","diagnostics-Diagnostics-vue":"diagnostics-Diagnostics-vue","Dashboard-vue~Document-vue~Documents-vue~Issues-vue":"Dashboard-vue~Document-vue~Documents-vue~Issues-vue","Documents-vue":"Documents-vue","Issues-vue":"Issues-vue","TrainingCourses-vue":"TrainingCourses-vue","AssessmentReview-vue":"AssessmentReview-vue","Dashboard-vue":"Dashboard-vue","Document-vue":"Document-vue","Help-vue~TrainingCourse-vue":"Help-vue~TrainingCourse-vue","TrainingCourse-vue":"TrainingCourse-vue","Messages-vue":"Messages-vue","ForgotPassword-vue~Help-vue~Status-vue":"ForgotPassword-vue~Help-vue~Status-vue","ForgotPassword-vue":"ForgotPassword-vue","Help-vue":"Help-vue","Status-vue":"Status-vue","TrainingExam-vue":"TrainingExam-vue","PageNotFound-vue":"PageNotFound-vue","lang-ar-EG-json":"lang-ar-EG-json","lang-da-DK-json":"lang-da-DK-json","lang-de-DE-json":"lang-de-DE-json","lang-es-MX-json":"lang-es-MX-json","lang-fr-CA-json":"lang-fr-CA-json","lang-ja-JP-json":"lang-ja-JP-json","lang-kl-GL-json":"lang-kl-GL-json","lang-pt-BR-json":"lang-pt-BR-json","lang-zh-CN-json":"lang-zh-CN-json"}[chunkId]||chunkId) + "." + {"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~ForgotPassword-vue~Form-vu~b09ba6e6":"bd4da8fd","Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~Form-vue~Forms-vue~Index-v~63b074e9":"128904c1","Account-vue~Documents-vue~ForgotPassword-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~I~2300ad8d":"5e6cddd0","Account-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~Login-vue~Planner-vue~Planners-vue~c740871e":"c667fd9f","Account-vue":"e8cede0a","Form-vue":"2d36ef7c","Forms-vue":"8fac53b8","Index-vue":"5d30395e","Inspection-vue":"b7c7daa2","Issue-vue":"b9d69347","Login-vue":"c92f3540","Planner-vue":"fe2a419c","Planners-vue":"d4f6e57b","RegisterUser-vue":"8b9271f7","Reports-vue":"6f429d95","TimeClock-vue":"ad422589","TimeClockDetail-vue":"0aeb48ba","diagnostics-Diagnostics-vue":"5fc34313","Dashboard-vue~Document-vue~Documents-vue~Issues-vue":"ba6fd502","Documents-vue":"fe5d1da4","Issues-vue":"44b511ed","TrainingCourses-vue":"d90f8302","AssessmentReview-vue":"07cd71c8","Dashboard-vue":"141bc369","Document-vue":"7902710e","Help-vue~TrainingCourse-vue":"b0a5d032","TrainingCourse-vue":"bf86bd66","Messages-vue":"53e0d8dd","ForgotPassword-vue~Help-vue~Status-vue":"ee4bc94b","ForgotPassword-vue":"e5348923","Help-vue":"d8ccfd4f","Status-vue":"35d2a63b","TrainingExam-vue":"53b4ba8c","PageNotFound-vue":"5b0a27a9","chunk-2d0abc10":"d757786d","chunk-2d0c8407":"d4c26803","chunk-2d230c96":"503703fd","lang-ar-EG-json":"e0377d14","lang-da-DK-json":"f269b258","lang-de-DE-json":"61ab2e01","lang-es-MX-json":"66a84268","lang-fr-CA-json":"2511e662","lang-ja-JP-json":"89fb90a5","lang-kl-GL-json":"dd6c3b9c","lang-pt-BR-json":"119c2bf3","lang-zh-CN-json":"2452c250","chunk-2d208e4e":"b047ec48","chunk-2d0a4885":"5c00a674","chunk-2d0f0050":"43ca0cc8","chunk-2d216214":"0bbc55e6","chunk-670b10c3":"59ecbfff"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~ForgotPassword-vue~Form-vu~b09ba6e6":1,"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~Form-vue~Forms-vue~Index-v~63b074e9":1,"Account-vue~Documents-vue~ForgotPassword-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~I~2300ad8d":1,"Account-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~Login-vue~Planner-vue~Planners-vue~c740871e":1,"Account-vue":1,"Form-vue":1,"Forms-vue":1,"Index-vue":1,"Inspection-vue":1,"Issue-vue":1,"Login-vue":1,"Planner-vue":1,"Planners-vue":1,"RegisterUser-vue":1,"Reports-vue":1,"TimeClock-vue":1,"TimeClockDetail-vue":1,"diagnostics-Diagnostics-vue":1,"Dashboard-vue~Document-vue~Documents-vue~Issues-vue":1,"Documents-vue":1,"Issues-vue":1,"TrainingCourses-vue":1,"AssessmentReview-vue":1,"Dashboard-vue":1,"Document-vue":1,"TrainingCourse-vue":1,"Messages-vue":1,"ForgotPassword-vue~Help-vue~Status-vue":1,"ForgotPassword-vue":1,"Help-vue":1,"Status-vue":1,"TrainingExam-vue":1,"PageNotFound-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~ForgotPassword-vue~Form-vu~b09ba6e6":"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~ForgotPassword-vue~Form-vu~b09ba6e6","Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~Form-vue~Forms-vue~Index-v~63b074e9":"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~Form-vue~Forms-vue~Index-v~63b074e9","Account-vue~Documents-vue~ForgotPassword-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~I~2300ad8d":"Account-vue~Documents-vue~ForgotPassword-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~I~2300ad8d","Account-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~Login-vue~Planner-vue~Planners-vue~c740871e":"Account-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~Login-vue~Planner-vue~Planners-vue~c740871e","Account-vue":"Account-vue","Form-vue":"Form-vue","Forms-vue":"Forms-vue","Index-vue":"Index-vue","Inspection-vue":"Inspection-vue","Issue-vue":"Issue-vue","Login-vue":"Login-vue","Planner-vue":"Planner-vue","Planners-vue":"Planners-vue","RegisterUser-vue":"RegisterUser-vue","Reports-vue":"Reports-vue","TimeClock-vue":"TimeClock-vue","TimeClockDetail-vue":"TimeClockDetail-vue","diagnostics-Diagnostics-vue":"diagnostics-Diagnostics-vue","Dashboard-vue~Document-vue~Documents-vue~Issues-vue":"Dashboard-vue~Document-vue~Documents-vue~Issues-vue","Documents-vue":"Documents-vue","Issues-vue":"Issues-vue","TrainingCourses-vue":"TrainingCourses-vue","AssessmentReview-vue":"AssessmentReview-vue","Dashboard-vue":"Dashboard-vue","Document-vue":"Document-vue","Help-vue~TrainingCourse-vue":"Help-vue~TrainingCourse-vue","TrainingCourse-vue":"TrainingCourse-vue","Messages-vue":"Messages-vue","ForgotPassword-vue~Help-vue~Status-vue":"ForgotPassword-vue~Help-vue~Status-vue","ForgotPassword-vue":"ForgotPassword-vue","Help-vue":"Help-vue","Status-vue":"Status-vue","TrainingExam-vue":"TrainingExam-vue","PageNotFound-vue":"PageNotFound-vue","lang-ar-EG-json":"lang-ar-EG-json","lang-da-DK-json":"lang-da-DK-json","lang-de-DE-json":"lang-de-DE-json","lang-es-MX-json":"lang-es-MX-json","lang-fr-CA-json":"lang-fr-CA-json","lang-ja-JP-json":"lang-ja-JP-json","lang-kl-GL-json":"lang-kl-GL-json","lang-pt-BR-json":"lang-pt-BR-json","lang-zh-CN-json":"lang-zh-CN-json"}[chunkId]||chunkId) + "." + {"Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~ForgotPassword-vue~Form-vu~b09ba6e6":"ac92844e","Account-vue~AssessmentReview-vue~Dashboard-vue~Document-vue~Documents-vue~Form-vue~Forms-vue~Index-v~63b074e9":"978fed1e","Account-vue~Documents-vue~ForgotPassword-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~I~2300ad8d":"3a13dd5f","Account-vue~Form-vue~Forms-vue~Index-vue~Inspection-vue~Issue-vue~Login-vue~Planner-vue~Planners-vue~c740871e":"72930a3c","Account-vue":"39d658db","Form-vue":"e38a4ed9","Forms-vue":"9e8913e5","Index-vue":"6359e0e6","Inspection-vue":"cda9ee5e","Issue-vue":"75fbf261","Login-vue":"d2aba0f0","Planner-vue":"d095d06b","Planners-vue":"95765286","RegisterUser-vue":"fd6c2036","Reports-vue":"302c9bcf","TimeClock-vue":"645cc9d9","TimeClockDetail-vue":"795f681d","diagnostics-Diagnostics-vue":"62ec5eff","Dashboard-vue~Document-vue~Documents-vue~Issues-vue":"99773839","Documents-vue":"c9e1158a","Issues-vue":"5505db9f","TrainingCourses-vue":"981be3f7","AssessmentReview-vue":"6d3362f1","Dashboard-vue":"7ea0e76e","Document-vue":"4ae0633f","Help-vue~TrainingCourse-vue":"31d6cfe0","TrainingCourse-vue":"0efd0526","Messages-vue":"5f42d7f4","ForgotPassword-vue~Help-vue~Status-vue":"e5d0263e","ForgotPassword-vue":"2841991a","Help-vue":"18ce7949","Status-vue":"b9b7a161","TrainingExam-vue":"f63f86c6","PageNotFound-vue":"983702bf","chunk-2d0abc10":"31d6cfe0","chunk-2d0c8407":"31d6cfe0","chunk-2d230c96":"31d6cfe0","lang-ar-EG-json":"31d6cfe0","lang-da-DK-json":"31d6cfe0","lang-de-DE-json":"31d6cfe0","lang-es-MX-json":"31d6cfe0","lang-fr-CA-json":"31d6cfe0","lang-ja-JP-json":"31d6cfe0","lang-kl-GL-json":"31d6cfe0","lang-pt-BR-json":"31d6cfe0","lang-zh-CN-json":"31d6cfe0","chunk-2d208e4e":"31d6cfe0","chunk-2d0a4885":"31d6cfe0","chunk-2d0f0050":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-670b10c3":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
